"use client";
import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Consultancy from "./components/about-us/Consultancy";
import Corporation from "./components/about-us/Corporation";
import Infra from "./components/about-us/Infra";
import Invention from "./components/about-us/Invention";
import Vision from "./components/about-us/Vision";
import About from "./components/common/components/about/About";
import BackToTop from "./components/common/components/BackToTop";
import Footer from "./components/common/components/Footer";
import Navigation from "./components/common/components/navigation/Navigation";
import TopNav from "./components/common/components/TopNav";
import ContactUs from "./components/contact-us/ContactUs";
import Home from "./components/home/Home";
import MissionVisionMain from "./components/mission-vision/MissionVisionMain";
import GalleryMain from "./components/story-in-pictures/GalleryMain";
import Blogs from "./components/updates-and-insights/Blogs";
import AboutEnterpreneur from "./components/about-enterpreneur/AboutEnterpreneur";
import Motivational from "./components/motivational/Motivational";
import Inventors from "./components/inventors/Inventors";
import NewHero from "./components/new-hero/NewHero";
import Reward from "./components/buy-now/Reward";
import AchieveMentsPage from "./components/achievements/AchieveMentsPage";
import MediaPage from "./components/media/MediaPage";
import ArticlesPage from "./components/articles/ArticlesPage";
import SocialitePage from "./components/socialite/SocialitePage";
import CollabrationPage from "./components/collabration/CollabrationPage";
import PrivacyPolicyPage from "./components/privacy-policy/PrivacyPolicyPage";
import PrivacySecuritypage from "./components/privacy-security/PrivacySecuritypage";
import TermsPage from "./components/terms-usage/TermsPage";

function App() {
  const path = useLocation().pathname;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [path]);
  return (
    <div>
      <TopNav />
      <div className="sticky top-0 z-50 bg-white">
        <Navigation />
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/mission" element={<MissionVisionMain />} />
        <Route path="/gallery" element={<GalleryMain />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/india-infra" element={<Infra />} />
        <Route path="/india-consultancy" element={<Consultancy />} />
        <Route path="/india-invention" element={<Invention />} />
        <Route path="/india-corporation" element={<Corporation />} />
        <Route path="/about-entrepreneur" element={<AboutEnterpreneur />} />
        <Route path="/motivational-speaker" element={<Motivational />} />
        <Route path="/inventors" element={<Inventors />} />
        <Route path="/author" element={<NewHero />} />
        <Route path="/rewards" element={<Reward />} />
        <Route path="/achievements" element={<AchieveMentsPage />} />
        <Route path="/media-interview" element={<MediaPage />} />
        <Route path="/articles" element={<ArticlesPage />} />
        <Route path="/socialite" element={<SocialitePage />} />
        <Route path="/collaboration" element={<CollabrationPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/privacy-security" element={<PrivacySecuritypage />} />
        <Route path="/terms-conditions" element={<TermsPage />} />
      </Routes>
      {path !== "/rewards" && (
        <>
          <Footer />
          <div
            className="fixed bottom-2 right-2 min-[1940px]:right-[calc((100vw-1920px)/2)]
 sm:bottom-4 sm:right-4 z-40">
            <BackToTop />
          </div>
        </>
      )}
    </div>
  );
}

export default App;
